/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { postRequest } from '../../utils/client/client';
import { downloadFile, keysToSnake } from '@/utils';

export async function downloadImportTemplate(fileName: string, requestData: object, csrfToken: string) {
  try {
    const exportRequest: string = `{"filter": ${JSON.stringify(keysToSnake(requestData))}}`;
    const responseData = await postRequest({
      url: '/_service/import_template',
      data: exportRequest,
      headers: {
        'Content-Type': 'application/json',
        'X-export-view': 'blocks',
        'X-requested-by': 'gGRC',
        'X-CSRFToken': csrfToken,
      },
    });
    return downloadFile(responseData, 'text/csv', fileName);
  } catch (e) {
    throw {
      type: 'error',
      message: 'Something went wrong.',
    };
  }
}

export function generateDownloadTemplateData(managedIn: string, code: string, newTicketingFlag: boolean): object {
  let objectName: string;
  let fields: Array<string>;

  if (managedIn === 'JIRA') {
    objectName = 'JiraIssue';
    fields = ['title', 'description', '__custom_attributes__', 'jira_issue_controls'];
  } else if (managedIn === 'SERVICENOW') {
    if (newTicketingFlag) {
      objectName = 'TicketingTask';
      fields = [
        'title',
        'description',
        'assigned_to',
        'assignment_group',
        'due_date',
        '__custom_attributes__',
        'ticketing_task_controls',
      ];
    } else {
      objectName = 'ServiceNowTask';
      fields = ['title', 'description', '__custom_attributes__'];
    }
  } else {
    objectName = 'Request';
    fields = [
      'code',
      'title',
      'description',
      'notes',
      'related_assignees',
      'reviewers',
      'related_verifiers',
      'start_date',
      'end_date',
      '__custom_attributes__',
    ];
  }

  return [
    {
      objectName: objectName,
      fields: fields,
      extra: {
        audit: code,
      },
    },
  ];
}
